'use client';

import { type ComponentPropsWithRef } from 'react';

import { VisuallyHidden } from '@repo/ui/VisuallyHidden';
import { Chip } from '@repo/ui/Chip';
import type { ChipBaseProps } from './Chip.tsx';
import { Radio } from '@repo/ui/Radio';

export type RadioChipProps = ChipBaseProps &
  ComponentPropsWithRef<'input'> & {
    id: string;
    name: string;
    value: string;
  };

export const RadioChip = (props: RadioChipProps) => {
  const {
    ariaDisabled,
    children,
    className,
    disabled,
    id,
    isSelected,
    name,
    value,
    ...rest
  } = props;

  if (!children) {
    return null;
  }

  return (
    <Chip
      asChild
      ariaDisabled={ariaDisabled}
      className={className}
      disabled={disabled}
      isSelected={isSelected}
    >
      <label htmlFor={id}>
        <VisuallyHidden asChild>
          <Radio id={id} name={name} value={value} {...rest} />
        </VisuallyHidden>
        {children}
      </label>
    </Chip>
  );
};
